<template>
  <div class="login-container">
    <h1 style="color: #005D8A">lebillet</h1>
    <div class="login-wrapper">
      <div>
        <v-text-field v-model="email" label="E-mail"></v-text-field>
      </div>
      <div>
        <v-text-field type="password" v-model="password" label="Password"></v-text-field>
      </div>
      <v-btn color="primary" @click.native="login" @keyup.enter="login">Login</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('setCurrentPage', '')
  },
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login() {
      this.$store.dispatch('doLogin', { email: this.email, password: this.password, router: this.$router })
    }
  }
}
</script>

<style>
.login-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loginImg {
  max-width: 130px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
}
.login-wrapper {
  padding: 8px;
  margin: 8px;
  border: 1px solid #979797;
  border-top: 4px solid #005d8a;
  width: 95%;
  max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue